
// dawn copy paste

class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
    }
  
    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
  
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
      }
    }
  
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }
  
    updateMedia() {
      if (!this.currentVariant || !this.currentVariant?.featured_media) return;
      const newMedia = document.querySelector(
        `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
      );
      if (!newMedia) return;
      const parent = newMedia.parentElement;
      parent.prepend(newMedia);
      window.setTimeout(() => { parent.scroll(0, 0) });
    }
  
    updateURL() {
      if (!this.currentVariant) return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  
    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;
  
      if (this.currentVariant?.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }
  
    renderProductInfo() {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const id = `price-${this.dataset.section}`;
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(id);
          const source = html.getElementById(id);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
  
          document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
          this.toggleAddButton(!this.currentVariant.available, 'épuisé');
        });
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
      const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
  
      if (!addButton) return;
  
      if (disable) {
        addButton.setAttribute('disabled', true);
        if (text) addButton.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButton.textContent = window.variantStrings.addToCart;
      }
  
      if (!modifyClass) return;
    }
  
    setUnavailable() {
      const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
      if (!addButton) return;
      addButton.textContent = window.variantStrings.unavailable;
      document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
    }
  
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  
  customElements.define('variant-selects', VariantSelects);
  
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }
  
    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(input => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.classList.remove('disabled');
        } else {
          input.classList.add('disabled');
        }
      });
    }
  
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }
  
  customElements.define('variant-radios', VariantRadios);
  
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
  
      this.input.addEventListener('change', this.onInputChange.bind(this));
      this.querySelectorAll('button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
  
    quantityUpdateUnsubscriber = undefined;
  
    connectedCallback() {
      this.validateQtyRules();
      this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    }
  
    disconnectedCallback() {
      if (this.quantityUpdateUnsubscriber) {
        this.quantityUpdateUnsubscriber();
      }
    }
  
    onInputChange(event) {
      this.validateQtyRules();
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
  
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
  
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        const buttonMinus = this.querySelector(".quantity__button[name='minus']");
        buttonMinus.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        const buttonPlus = this.querySelector(".quantity__button[name='plus']");
        buttonPlus.classList.toggle('disabled', value >= max);
      }
    }
  }
  
  customElements.define('quantity-input', QuantityInput);

  class NewsletterTags extends HTMLElement {
    constructor() {
      super();
      this.radioButtons = this.querySelectorAll('input[name="newsletter_preference"]');
      this.submitButton = this.querySelector('button[type="submit"]');

      if (this.submitButton !== null) {
        this.submitButton.disabled = true;
      }
      
      var self = this;
      document.addEventListener("DOMContentLoaded", function() {        
        self.radioButtons.forEach(function(radioButton) {
          radioButton.addEventListener('change', function() {
            var selectedValue = document.querySelector('input[name="newsletter_preference"]:checked').value;
            document.querySelector('#ContactFooter input[name="contact[tags]"]').value = "newsletter,newsletter_" + selectedValue;
            if (self.submitButton !== null) {
              self.submitButton.disabled = false;
            }
          });
        });
      });
    }

  }
  
  customElements.define('newsletter-tags', NewsletterTags);


  // Get the button
  let button_faq_go_on_top = document.querySelector(".faq__go-on-top");
  if (button_faq_go_on_top !== null) {
      // When the user scrolls down 20px from the top of the document, show the button
    window.onscroll = function () {
      scrollFunction()
    };

    function scrollFunction() {
        if (document.body.scrollTop > 1000 || document.documentElement.scrollTop > 1000) {
          button_faq_go_on_top.classList.add('active');
        } else {
          button_faq_go_on_top.classList.remove('active');
        }
    }

    function scrollTo(element) {
        window.scroll({
            behavior: 'smooth',
            left: 0,
            top: 0
        });
    }

    button_faq_go_on_top.addEventListener('click', () => {
        scrollTo();
    }); 
  }



var all_products_2 = [];

function populateProducts() {
  var cache = {};
  // 1. Query product json

  // 2. Query product metafields
  const query = `query ProductMetafields {
			products(first: 80) {
				edges {
					node {
						handle
						onlineStoreUrl
						has_subscription: metafield(namespace: "subscriptions", key: "has_subscription") {
			value
			key
		  }
		  discount_percentage: metafield(namespace: "subscriptions", key: "discount_percentage") {
			value
			key
		  }
		  subscription_id: metafield(namespace: "subscriptions", key: "subscription_id") {
			value
			key
		  }
		  shipping_interval_frequency: metafield(namespace: "subscriptions", key: "shipping_interval_frequency") {
			value
			key
		  }
		  shipping_interval_unit_type: metafield(namespace: "subscriptions", key: "shipping_interval_unit_type") {
			value
			key
		  }
		  discount_product_id: metafield(namespace: "subscriptions", key: "discount_product_id") {
			value
			key
		  }
		  last_sync_timestamp: metafield(namespace: "subscriptions", key: "last_sync_timestamp") {
			value
			key
		  }
		  original_to_hidden_variant_map: metafield(namespace: "subscriptions", key: "original_to_hidden_variant_map") {
			value
			key
		  }
						variants(first: 20) {
							edges {
								node {
									discount_variant_id: metafield(namespace: "subscriptions", key: "discount_variant_id") {
				  value
				  key
				}
				discount_variant_price: metafield(namespace: "subscriptions", key: "discount_variant_price") {
				  value
				  key
				}
								}
							}
						}
					}
				}
			}
		}`
  const params = {
    query: query
  }
  const optionsQuery = {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-Shopify-Storefront-Access-Token": 'f30850f961aadcf23f39666a3041d658'
    },
    body: JSON.stringify(params)
  };
  return fetch(`/api/2023-07/graphql`, optionsQuery)
      .then(res => res.json())
      .then(function (response) {
        cache.productMetafieldResponse = response;
        var push = {product: {}, metafields: {}};
        var queryProducts = cache.productMetafieldResponse.data.products.edges;
        var queryProduct = null;
        var index = -1;
        for (var i = 0; i < queryProducts.length; i++) {
          queryProduct = queryProducts[i];
          for (var k = 0; k < all_products.length; k++) {
            var objectProduct = all_products[k].product;
            if (objectProduct.handle == queryProduct.node.handle) {

              if (queryProduct.node.has_subscription != null) {
                all_products[k].metafields[queryProduct.node.has_subscription.key] = queryProduct.node.has_subscription.value;
              }

              if (queryProduct.node.discount_percentage != null) {
                all_products[k].metafields[queryProduct.node.discount_percentage.key] = queryProduct.node.discount_percentage.value;
              }

              if (queryProduct.node.subscription_id != null) {
                all_products[k].metafields[queryProduct.node.subscription_id.key] = queryProduct.node.subscription_id.value;
              }

              if (queryProduct.node.shipping_interval_frequency != null) {
                all_products[k].metafields[queryProduct.node.shipping_interval_frequency.key] = queryProduct.node.shipping_interval_frequency.value;
              }

              if (queryProduct.node.shipping_interval_unit_type != null) {
                all_products[k].metafields[queryProduct.node.shipping_interval_unit_type.key] = queryProduct.node.shipping_interval_unit_type.value;
              }

              if (queryProduct.node.discount_product_id != null) {
                all_products[k].metafields[queryProduct.node.discount_product_id.key] = queryProduct.node.discount_product_id.value;
              }

              if (queryProduct.node.last_sync_timestamp != null) {
                all_products[k].metafields[queryProduct.node.last_sync_timestamp.key] = queryProduct.node.last_sync_timestamp.value;
              }

              if (queryProduct.node.original_to_hidden_variant_map != null) {
                all_products[k].metafields[queryProduct.node.original_to_hidden_variant_map.key] = queryProduct.node.original_to_hidden_variant_map.value;
              }

              if (all_products[k].variants) {
                for (var l = 0; l < all_products[k].variants.length; l++) {
                  var queryVariant = queryProduct.node.variants.edges[l];
                  if (!queryVariant || !queryVariant.node.discount_variant_id || !queryVariant.node.discount_variant_price) continue

                  if (queryVariant.node.discount_variant_id != null) {
                    all_products[k].variants[l].metafields[queryVariant.node.discount_variant_id.key] = queryVariant.node.discount_variant_id.value
                  }
                  if (queryVariant.node.discount_variant_price != null) {
                    all_products[k].variants[l].metafields[queryVariant.node.discount_variant_price.key] = queryVariant.node.discount_variant_price.value
                  }
                }
              }
            }

          }
        }
        $(window).trigger('productLoaded');
        $(window).trigger('cartLoaded');
      });
}

setTimeout(function () {
  populateProducts();
}, 500);

var klaviyo_form_trigger_desktop = document.querySelector('.klaviyo_form_trigger.only-desktop');
var klaviyo_form_trigger_mobile = document.querySelector('.klaviyo_form_trigger.only-mobile');
if (klaviyo_form_trigger_desktop) {
  klaviyo_form_trigger_desktop.addEventListener('click', function () {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'R8NxvG']);
  });
}
if (klaviyo_form_trigger_mobile) {
  klaviyo_form_trigger_mobile.addEventListener('click', function () {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'TN9eEY']);
  });
}

// NAVIGATION LINK TRACKING

// Resolve dog/cat from the clicked item first (href + label), then parent menu title/href.
// Parent menu URLs alone are unreliable (nolink, chien-et-chat, or first sublink mismatches).
function resolveMenuSpecies($mega) {
  var sources = [
    $mega.attr('href') || '',
    $mega.find('.megamenu-image__button').text() || '',
    $mega.closest('.header__menu-item').find('.header__menu-link').first().text() || '',
    $mega.closest('.side-nav__link-container').find('[data-menu-open]').first().text() || '',
    $mega.closest('.header__menu-item').find('.header__menu-link').first().attr('href') || '',
    $mega.closest('.side-nav__link-container').find('[data-menu-open]').attr('data-double-link') || '',
  ];

  for (var i = 0; i < sources.length; i++) {
    var source = String(sources[i]).toLowerCase().replace(/\s+/g, ' ');
    var hasDog = source.indexOf('chien') !== -1;
    var hasCat = source.indexOf('chat') !== -1;
    if (hasDog && !hasCat) return 'dog';
    if (hasCat && !hasDog) return 'cat';
  }

  return null;
}

function navigationClickTracker(container, eventType) {
  $(container).on('click', function(e) {
    var $target = $(e.target);
    if ($target.closest('[data-header-track]').length) return;
    var $mega = $target.closest('.megamenu-image-container, .megamenu-image__container');

    // Desktop + mobile megamenu product/quiz highlights
    if ($mega.length) {
      var species = resolveMenuSpecies($mega);
      var productText = $mega.find('.megamenu-image__button').text().trim() || $mega.text().trim();
      var productLink = $mega.attr('href') || '';
      var highlightName = null;

      if ($mega.hasClass('is-questionaire')) {
        if (species === 'dog') highlightName = 'click_dog_quizz_highlight_menu';
        else if (species === 'cat') highlightName = 'click_cat_quizz_highlight_menu';
      } else if (species === 'dog') {
        highlightName = 'click_dog_product_highlight_menu';
      } else if (species === 'cat') {
        highlightName = 'click_cat_product_highlight_menu';
      }

      if (highlightName) {
        window.dispatchEvent(
          new CustomEvent('hb_navigation_click', {
            detail: {
              type: eventType,
              name: highlightName,
              click_text: productText,
              click_link: productLink,
            },
          })
        );
        return;
      }
    }

    // Generic link clicks — use closest('a') so nested mobile markup still tracks
    // (side-nav wraps labels in <a><div>…</div></a>, so e.target is often not the <a>)
    var $link = $target.closest('a');
    if ($link.length && $.contains(this, $link[0])) {
      var clickText = $link.text().trim().replace(/\s+/g, ' ');
      var detail = {
        type: eventType,
        name: 'click_' + clickText.split(' ').join('_').toLowerCase() + '_menu',
        click_text: clickText,
        click_link: $link.attr('href'),
      };
      window.dispatchEvent(new CustomEvent('hb_navigation_click', { detail: detail }));
    }
  });
}

// HEADER NAVIGATION TRACKING (desktop)
navigationClickTracker('[role="navigation"]', "header_click");

// BURGER / SIDE NAV TRACKING (mobile)
navigationClickTracker('[data-header-side-nav]', "header_click");

// FOOTER NAVIGATION TRACKING
navigationClickTracker('.footer__navigations', "footer_click");
